// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import moduleExports from '@/api/index';
import "babel-polyfill"
import '@/assets/css/font.css'

Vue.prototype.$API = moduleExports
Vue.config.productionTip = false
//图片轮播
import VueAwesomeSwiper from 'vue-awesome-swiper'
import '../node_modules/swiper/dist/css/swiper.css'
Vue.use(VueAwesomeSwiper)
import scroll from 'vue-seamless-scroll'
Vue.use(scroll)
//引入iview
import iView from 'iview';
import 'iview/dist/styles/iview.css';

Vue.use(iView);
import '@/utils/rem.js'
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: {App},
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js